/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
namespace('Slzr.Theme.ConferenceShow', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  return $(function() {
    if (!$(document.body).is('.em-event_feedback--page')) { return; }

    return $('.em-event_feedback--toggle-sessions').click(function() {
      const $this = $(this);
      const $container = $(`#${  $this.attr('aria-controls')}`);

      if ($this.is('.em-event_feedback--toggle-sessions-open')) {
        // hide it
        $container.hide();
        return $this.attr('aria-expanded', 'false')
          .removeClass('em-event_feedback--toggle-sessions-open');
      } 
        // show it
        $container.show();
        return $this.attr('aria-expanded', 'true')
          .addClass('em-event_feedback--toggle-sessions-open');
      
    });
  });
});

